<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild">
    <div id="language" style="float: right;margin-right: 20px;margin-top: 20px">
      <a href="https://www.jbvalves.net/">简体中文</a>
      |
      <a href="https://www.jbvalves.net/en">English</a>
    </div>
    <!-- 电脑导航 -->
    <div class="top" style="min-width: 1200px">
      <div class="center">
        <div class="top_logo">
          <a href="/">
            <img src="/static/img/header/logo_top.png" alt=""/>
          </a>
        </div>
        <div class="top_center">
          <div class="nav">
            <ul>
              <li
                v-for="(item,index) in navList"
                :key="index"
                :class="index===navIndex?'active':''"
                @click="navClick(index,item.name)">
                <router-link :to="item.path">
                  {{item.name}}
                  <span v-if="item.children.length>0" class="glyphicon glyphicon-menu-down"></span>
                  <i class="underline"></i>
                </router-link>
                <dl v-if="item.children.length>0">
                  <dt v-for="(i,n) in item.children" :key="n">
                    <router-link :to="i.path">{{i.name}}</router-link>
                  </dt>
                </dl>
              </li>

            </ul>

          </div>
        </div>
       <!-- <div class="top_right">
          <img src="/static/img/header/search.png" alt=""/>
          <input id="searchInfo"></input>
          <button @click="searchProduct()"></button>
          &lt;!&ndash;<img src="/static/img/header/telephone.png" alt=""/>&ndash;&gt;
        </div>-->
      </div>
    </div>

    <!--<div class="nav" style="background-color: #EDEDED;">
      <div class="center">
        <ul>
          <li
            v-for="(item,index) in navList"
            :key="index"
            :class="index===navIndex?'active':''"
            @click="navClick(index,item.name)">
            <router-link :to="item.path">
              {{item.name}}
              <span v-if="item.children.length>0" class="glyphicon glyphicon-menu-down"></span>
              <i class="underline"></i>
            </router-link>
            <dl v-if="item.children.length>0">
              <dt v-for="(i,n) in item.children" :key="n">
                <router-link :to="i.path">{{i.name}}</router-link>
              </dt>
            </dl>
          </li>
        </ul>
      </div>
    </div>-->
  </div>
</template>
<script>
    import '@/assets/css/cpjfw.css';
    import '@/assets/css/shouye.css';

    export default {
        name: "Header",
        data() {
            return {
                searchInfo: '',

                contract: {
                    name: '',
                    content: '',
                    telephoneNum: '',
                    email: '',
                    address: ''
                },
                swiperList: [],
                navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
                menuName: "首页",
                menuClass: "glyphicon glyphicon-menu-down",
              navLanguage:[
                {
                  name: "官网首页",
                  path: "/",
                  children: []
                },
                {
                  name: "HomePage",
                  path: "/en/",
                  children: []
                }
              ],
                navList: [
                    {
                        name: "官网首页",
                        path: "/",
                        children: []
                    },
                    {
                        name: "公司简介",
                        path: "/companyIntroduction",
                        children: []
                    },
                    {
                        name: "产品中心",
                        path: "/productCenter",
                        children: []
                    },

                    {
                        name: "联系我们",
                        path: "/contactUs",
                        children: []
                    }
                ]
            };

        },
        created() {
          this.$global.language="en"
          console.log("global?"+this.$global.language)
            this.getProductType()
            //this.getData()
            //this.getContract()
        },
        methods: {
            // 根据输入的内容搜索并跳转至产品页面
            searchProduct(){
                let val = document.getElementById("searchInfo").value
                if(val !== "" && val != null){
                    this.$router.push({
                        path: '/productCenter',
                        name: 'ProductCenter',
                        query: {info: val},
                        component: resolve => require(['@/view/ProductCenter'], resolve),
                        meta: {
                            title: '产品列表'
                        }
                    });
                }
            },
            getProductType() {
                this.$http({
                    method: 'post',
                    url: '/getProduceType',
                    params: {},
                })
                    .then((data) => {
                        //  this.navList[1].children = data.data.msg
                    }).catch((error) => {
                    console.warn(error)
                })
            },
            navClick(index, name) {
                this.navIndex = index;
                sessionStorage.setItem('navIndex', index)
                this.menuName = name;
            },
        }
    };
</script>
<style scoped>
  /* 顶部 */
  #header {
    background: white;
    transition: all ease 0.6s;
  }

  #header .header-top {
    height: 50px;
    color: #fff;
    font-size: 12px;
    line-height: 50px;
    background: #474747;
  }

  /* 顶部的图标 */
  #header .header-top span {
    margin: 0 8px;
  }

  /* 导航栏 */
  #header .header-nav {
    height: 110px;
  }

  /* 导航栏logo */
  #header .header-nav .header-nav-logo {
    width: 100px;
    height: 100%;
    float: left;
    position: relative;
  }

  /* 导航栏logo图片 */
  #header .header-nav .header-nav-logo img {
    width: 95px;
    height: 45px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }

  /* 导航栏 导航容器 */
  #header .header-nav-fixed .header-nav-wrapper {
    line-height: 50px;
  }

  #header .header-nav .header-nav-wrapper {
    line-height: 110px;
    float: right;
    margin: 0;
    max-width: 800px;
  }

  /* 导航栏 每个导航 */
  #header .header-nav .header-nav-wrapper > li {
    float: left;
    margin: 0 15px;
    position: relative;
  }

  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav .header-nav-wrapper > li > a {
    color: #000;
    font-size: 15px;
    font-weight: bold;
    padding: 15px 0;
    position: relative;
  }

  /* 导航栏 每个导航下面的 a 链接的下划线 */
  #header .header-nav .header-nav-wrapper > li > a > i {
    display: block;
    position: absolute;
    bottom: -2px;
    left: 50%;
    width: 0;
    height: 2px;
    opacity: 0;
    transition: all 0.6s ease;
    background-color: #1e73be;
  }

  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper > li > a > span {
    font-size: 12px;
    transition: transform ease 0.5s;
  }

  /* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
  #header .header-nav .header-nav-wrapper > li > a:hover {
    color: #1e73be;
    text-decoration: none;
  }

  /* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
  #header .header-nav .header-nav-wrapper > li > a:hover .underline {
    opacity: 1;
    width: 100%;
    left: 0;
  }

  /* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
  #header .header-nav .header-nav-wrapper > li > a:hover span {
    transform: rotate(180deg);
  }

  /* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
  #header .header-nav .header-nav-wrapper > li.active > a {
    color: #1e73be;
    text-decoration: none;
    border-bottom: 2px solid #1e73be;
  }

  /* 导航栏 每个导航下面的二级导航容器 */
  #header .header-nav .header-nav-wrapper > li > dl {
    display: none;
    position: absolute;
    width: 168px;
    top: 80%;
    left: 0;
    z-index: 999999;
    box-shadow: 0 0 3px 1px #ccc;
    background: #fff;
  }

  /* 导航栏 每个导航下面的二级导航容器的每个导航 */
  #header .header-nav .header-nav-wrapper > li > dl > dt {
    width: 100%;
    padding: 10px;
    border-bottom: 1px solid #ccc;
  }

  /* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
  #header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
    text-decoration: none;
  }

  /* 导航栏 滑上一级导航显示二级导航 */
  #header .header-nav .header-nav-wrapper > li:hover dl {
    display: block;
  }

  #header .header-nav .header-nav-wrapper > li > dl > dt:hover {
    cursor: pointer;
    background: #ccc;
  }

  /*@media screen and (max-width: 997px) {
    #header .header-nav-m {
      position: relative;
    }
    !* 导航栏logo容器 *!
    #header .header-nav-m .header-nav-m-logo {
      height: 80px;
      position: relative;
    }
    !* 导航栏logo图片 *!
    #header .header-nav-m .header-nav-m-logo img {
      width: 95px;
      height: 45px;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
    }
    !* 导航栏  菜单容器 *!
    #header .header-nav-m .header-nav-m-menu {
      color: #fff;
      height: 50px;
      font-size: 20px;
      line-height: 50px;
      background: #474747;
      position: relative;
    }
    !* 导航栏 菜单图标 *!
    #header .header-nav-m .header-nav-m-menu-wrapper {
      position: absolute;
      top: 50%;
      right: 20px;
      margin-top: -20px;
      width: 50px;
      height: 40px;
      color: #fff;
      z-index: 999999;
      font-size: 12px;
    }
    !* 导航栏 *!
    #header .header-nav-m .header-nav-m-wrapper {
      position: absolute;
      top: 50px;
      left: 0;
      width: 100%;
      background: #474747;
      z-index: 9999999;
    }
    !* 导航栏 每个导航 *!
    #header .header-nav-m .header-nav-m-wrapper > li {
      height: 40px;
      line-height: 40px;
      border-bottom: 1px solid #ccc;
    }
    !* 导航栏 每个导航下面的 a 链接 *!
    #header .header-nav-m .header-nav-m-wrapper > li > a {
      color: #fff;
      font-size: 15px;
      font-weight: bold;
      padding: 15px 0;
      position: relative;
    }
    !* 导航栏 每个导航下面的 a 链接的右侧小三角 *!
    #header .header-nav .header-nav-wrapper > li > a > span {
      font-size: 10px;
    }
  }*/
  a {
    text-decoration: none
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue